//Library Imports
import React from "react";
import { useSelector } from "react-redux";
//Local Imports
import { RootState } from "store";
import ActionNode from "./ActionNode";
import ConditionNode from "./ConditionNode";
import { ControlTypeEnum, ControlNameEnum } from "../interfaces";

interface IRecursiveComponent {
  id: string;
  item: any;
  scaling: string;
}

export default function RecursiveComponent(props: IRecursiveComponent) {
  const workflow = useSelector((state: RootState) => state.automation.workflow.flow);
  const copiedNode = useSelector((state: RootState) => state.automation.workflow.copiedNode);
  const { id, item, scaling } = props;

  const buildTree = () => {
    let element = [];
    if (item?.detail?.controlType === ControlTypeEnum.ACTION) {
      // The some() method tests whether at least one element in the array passes the test implemented by the provided function
      // here I used it instead of .length check because somethings childNodes has empty string.
      let hasChildren = item?.childNodes?.some((child: string) => !!child === true);
      const { controlName, nodeTitle, title: controlTitle, ...other } = item?.detail;
      element.push(
        <ActionNode
          controlName={`${controlName}`}
          controlTitle={controlTitle}
          nodeTitle={`${nodeTitle || ""}`}
          uperline={true}
          downline={controlName !== ControlNameEnum.END}
          email={controlName === ControlNameEnum.SEND_EMAIL}
          list={controlName === ControlNameEnum.ADD_LIST}
          wait={controlName === ControlNameEnum.WAIT}
          end={controlName === ControlNameEnum.END}
          data={other}
          disabled={copiedNode.hasOwnProperty("nodeId")}
          id={id}
          key={`${id}-action`}
          hasChildren={hasChildren}
          scaling={scaling}
        />
      );
      if (hasChildren) {
        element.push(
          <RecursiveComponent
            id={item.childNodes[0]}
            item={workflow[item.childNodes[0]]}
            key={item.childNodes[0]}
            scaling={scaling}
          />
        );
      }
    } else if (item?.detail?.controlType === ControlTypeEnum.CONDITION) {
      const { controlName, nodeTitle, title, ...other } = item?.detail;
      element.push(
        <ConditionNode
          conditionLabel={`${item?.detail?.controlName}`}
          conditionRefrence={`${item?.detail?.nodeTitle}`}
          childrenLeft={
            <>
              <RecursiveComponent
                id={item?.childNodes[0]}
                item={workflow[item?.childNodes[0]]}
                scaling={scaling}
              />
            </>
          }
          childrenRight={
            <>
              <RecursiveComponent
                id={item?.childNodes[1]}
                item={workflow[item?.childNodes[1]]}
                scaling={scaling}
              />
            </>
          }
          disabled={copiedNode.hasOwnProperty("nodeId")}
          data={{ controlName, ...other }}
          id={id}
          key={`${id}-condition`}
          children={item?.childNodes}
          scaling={scaling}
        />
      );
    }
    return element;
  };

  return <>{buildTree()}</>;
}
